export const fieldEditButtonSelectorName = 'jira-issue-field-edit-field-edit-button';
